import React from "react";
import { DoorIconProps } from "./DeKaap";
import classNames from "classnames";

export const Eigenwijs: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2h23.273v56H2V2ZM0 60V0h27.273v60H0Zm3.763-45h1.858v-1H3.763v1Zm3.716 0h1.858v-1H7.479v1Zm3.716 0h1.858v-1h-1.858v1Zm3.716 0h1.857v-1h-1.857v1Zm3.715 0h1.858v-1h-1.858v1Zm3.716 0H24.2v-1h-1.858v1ZM5.622 31h-1.86v-1H5.62v1Zm3.715 0H7.479v-1h1.858v1Zm3.716 0h-1.858v-1h1.858v1Zm3.715 0h-1.857v-1h1.857v1Zm3.716 0h-1.858v-1h1.858v1Zm3.716 0h-1.858v-1H24.2v1ZM3.763 47h1.858v-1H3.763v1Zm3.716 0h1.858v-1H7.479v1Zm3.716 0h1.858v-1h-1.858v1Zm3.716 0h1.857v-1h-1.857v1Zm3.715 0h1.858v-1h-1.858v1Zm3.716 0H24.2v-1h-1.858v1Z"
        fill="#9493A3"
      />
    </svg>
  );
};
